import type { Rarity } from '@anidex/shared/economy';
import { formatCompact } from '../services/format';

interface FragmentCrystalProps {
  count: number;
  rarity: Rarity;
  imageUrl: string | null;
  size?: 'sm' | 'md' | 'lg';
  sparkle?: boolean;
  className?: string;
}

export function FragmentCrystal({ count, rarity, imageUrl, size = 'md', sparkle = false, className = '' }: FragmentCrystalProps) {
  const texture = imageUrl ? { backgroundImage: `url("${imageUrl.replace(/"/g, '%22')}")` } : undefined;
  return (
    <span
      className={`crystal crystal--${size} rarity-${rarity}${sparkle ? ' crystal--sparkle' : ''} ${className}`}
      role="img"
      aria-label={`${count} fragments`}
    >
      <span className="crystal__shape">
        <span className="crystal__gem" style={texture} />
        <span className="crystal__facets" />
      </span>
      <span className="crystal__count">{formatCompact(count)}</span>
    </span>
  );
}
